import Box from '@mui/material/Box';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import Tabs from '@mui/material/Tabs';
import logo from '../images/logo.png';

interface TopBarProps {
    children?: React.ReactNode;
    activeTab: number;
}

export default function TopBar(props: TopBarProps) {

    return (
        <AppBar position="fixed" sx={{ zIndex: (theme) => theme.zIndex.drawer + 1, backgroundColor: '#DEE7FF' }}>
            <Toolbar>
                <Box>
                    <img alt="logo" src={logo} height="50%" width="60%" />
                </Box>
                <Box sx={{ 
                    paddingLeft: {
                        xs: 1,
                        sm: 4,
                        md: 16
                    },
                    borderBottom: 0, borderColor: 'divider', alignSelf: 'flex-end' }}>
                    <Tabs
                        TabIndicatorProps={{
                            style: {
                                height: "4px",
                            }
                        }}
                        value={props.activeTab}
                        indicatorColor="secondary"
                        centered={true}
                        sx={{ height: '100%' }}
                    >
                        {props.children}
                    </Tabs>
                </Box>
                <Box sx={{ flexGrow: 1 }} />
            </Toolbar>
        </AppBar>
    )
}
